import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

// Color
export const ColorType = {
  ACCENT: 'accent',
  BASE: 'base',
  MODEST: 'modest',
  WHITE: 'white',
  ERROR: 'error'
}

// Font Size
export const SizeType = {
  XHUGE: 'xhuge',
  HUGE: 'huge',
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  TINY: 'tiny',
  XTINY: 'xtiny',
  XXTINY: 'xxtiny'
}

// weight
export const WeightType = {
  HEAVY: 'heavy',
  NORMAL: 'normal',
  LIGHT: 'light'
}

import './TextLabel.css'

const TextLabel = ({ children, color, size, weight }) => {
  return <p styleName={`${color} ${size} ${weight} text`}>{children}</p>
}

TextLabel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  color: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  weight: PropTypes.string.isRequired
}

TextLabel.defaultProps = {
  children: '',
  color: ColorType.BASE,
  size: SizeType.SMALL,
  weight: WeightType.NORMAL
}

export default compose(pure)(TextLabel)
